import { useCapability } from '@nx/state';
import type { ReactNode } from 'react';

import { DatabaseMenuButton } from './database-menu-button';
import { InstanceMenuButton } from './instance-menu-button';
import { LocalInstanceMenuButton } from './local-instance-menu-button';
import { UserMenuButton } from './user-menu-button';

type ConnectionBarProps = {
  actions?: ReactNode[];
};

export function ConnectionBar({ actions }: ConnectionBarProps) {
  const [showLocalInstances] = useCapability('framework:connection-bar-local-instances');
  return (
    <header className="bg-palette-neutral-bg-weak border-palette-neutral-border-weak flex min-h-8 flex-wrap items-center gap-x-4 border-b px-4">
      {showLocalInstances ? <LocalInstanceMenuButton /> : <InstanceMenuButton />}
      <DatabaseMenuButton />
      <UserMenuButton />

      {actions !== undefined && actions.length > 0 && (
        <div className="ml-auto flex items-center gap-1">{...actions}</div>
      )}
    </header>
  );
}
